import * as React from 'react'
import useAxios from 'axios-hooks'
import * as moment from 'moment-timezone'
import DownloadButton from '../files/DownloadButton'
import ProductionFilesButton from '../files/ProductionFilesButton'
import NavFolderButton from '../files/NavFolderButton'
import { formatBytes } from '../helpers/file'
import { downloadAttachments } from '../../api/files'
import { files_jobnumber_path } from '../../routes'
import FilePreviewPopup from './FilePreviewPopup'

interface FilesTableProps {
  jobnumber: {
    id: number
    job_id: string
    order_number: string
  }
}

export default function FilesTable({ jobnumber }: FilesTableProps) {
  const [{ data, loading, error }] = useAxios(
    {
      url: files_jobnumber_path(jobnumber.id, { format: 'json' }),
    },
    { useCache: false }
  )

  const folderButtons = (
    <>
      <ProductionFilesButton jobnumber={jobnumber} className="mr-2" />
      <NavFolderButton jobnumber={jobnumber} />
    </>
  )

  if (error) {
    return <div className="text-center">{error.message}</div>
  }

  if (loading) {
    return (
      <div className="text-center">
        <i className="fa fa-spinner fa-spin" />
      </div>
    )
  }
  if (!data.length) {
    return (
      <div className="text-center">
        {folderButtons}
        <div className="mt-3">{`There are no files for ID ${jobnumber.job_id}`}</div>
      </div>
    )
  }
  return (
    <>
      <div className="messages-download-attachments d-flex justify-content-between">
        <div>{folderButtons}</div>
        <DownloadButton jobnumber={jobnumber} downloadAttachments={downloadAttachments} />
      </div>
      <div className="">
        {data &&
          data.map((file) => {
            return (
              <div className="border-bottom" key={file.url}>
                <div className="mt-2 d-flex justify-content-between">
                  <div className="file-filename">
                    <a className="d-none d-lg-inline" href={file.url} target="_blank" rel="noopener noreferrer">
                      {file.filename}
                    </a>
                    <a className="d-inline d-lg-none" href={file.url} rel="noopener noreferrer">
                      {file.filename}
                    </a>
                    <div className="mb-2">
                      <small>
                        {formatBytes(file.size)},{' '}
                        {moment(file.last_modified).tz('Europe/Copenhagen').format('DD-MM-YYYY, HH:mm:ss')}
                      </small>
                    </div>
                  </div>
                  <div className="file-actions mt-1 text-nowrap">
                    <FilePreviewPopup file={file} files={data} currentIndex={data.indexOf(file)} />
                    <a className="ml-2 btn btn-outline-secondary" href={file.download_url}>
                      <i role="button" className="fa fa-icon fa-download" />
                    </a>
                  </div>
                </div>
              </div>
            )
          })}
      </div>
    </>
  )
}
